import React from "react";
import { func, string } from "prop-types";
import * as style from "./styles.module.scss";

const UploadingError = ({ fileCategory, onTryAgain }) => {
  return (
    <div className={style.fileUploadStatus__background}>
      <div className={style.fileUploadStatus__container}>
        <div className={style.fileUploadStatus__info}>
          <img src="/images/icons/timesheet-error.svg" />
          <h4 className="mt-2">Upload failed</h4>
          <span className="font-weight-bold">
            There has been an error uploading your {fileCategory}.
          </span>
          <span className="font-weight-bold">
            Please click on the button below to retry.
          </span>
        </div>
        <button
          className={`btn btn-primary ${style.fileUploadStatus__btn}`}
          onClick={onTryAgain}
        >
          Try Again
        </button>
      </div>
    </div>
  );
};

UploadingError.propTypes = {
  fileCategory: string.isRequired,
  onTryAgain: func.isRequired,
};

export default UploadingError;
